export enum Currency {
  Pts = 'Pts',
  Hkd = 'Hkd',
}
